enum ApiPlatformEnum {
	irw = 'irw',
	roig = 'roig'
}

export default ApiPlatformEnum;
